module.exports = __webpack_public_path__ + "img/Services.428c8138.png";